import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { P00061 } from '../../../../P00061';
import { getTemperature } from '../../../../../../helper/temperature';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import {
  PoolAdditionalData,
  PoolApi,
} from '../../../../../../../../apis/pool.api';

@Component({
  selector: 'app-p00061-chauffage-statut',
  templateUrl: './p00061-chauffage-statut.component.html',
  styleUrls: ['./p00061-chauffage-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
  ],
})
export class P00061ChauffageStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);
  private poolApi: PoolApi = inject(PoolApi);

  public actionStack: DeviceActionStackService | null = null;
  public additionalData: PoolAdditionalData | undefined | null = undefined;

  constructor() {}

  async ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    try {
      const poolId = this.edroNetworkManager.getPoolContext()?.pool?.id;
      if (poolId) {
        this.additionalData = await this.poolApi.getPoolAdditionalData(poolId);
      }
    } catch (error) {
      this.additionalData = {};
    }
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  get hasAlarm(): boolean {
    return this.getValue('wpSAlarme') === 1;
  }

  get produitP00061(): number {
    const master = getPoolMasterClass(
      this.edroNetworkManager.getPoolContext()!.pool!,
    );
    return (
      master?.hasProduct(
        this.edroNetworkManager.getPoolContext()!.pool!,
        new P00061(),
      ) ?? 0
    );
  }

  get codeDefautHasWarning(): boolean {
    return (
      this.getValue('wpSEtatSysteme') === 0 ||
      this.getValue('wpSDefautsPrincipauxCodeP01') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeP02') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeP04') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeP05') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeP07') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeP081') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE051') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE01') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE02') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE03') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE19') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE29') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE07') === 1 ||
      this.getValue('wpSDefautsPrincipauxSystem1') === 1 ||
      this.getValue('wpSDefautsPrincipauxCodeE06') === 1
    );
  }

  get registreDefauts2HasWarning(): boolean {
    return (
      this.getValue('wpSRegistreDefauts2CompressorOverloadProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts2HighPressureProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts2LowPressureProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts2WaterFlowProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts2AntifreezingProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts2HighDischargeTemperatureProtection') !==
        0 ||
      this.getValue('wpSRegistreDefauts2InputUnderVoltage') !== 0
    );
  }

  get registreDefauts3HasWarning(): boolean {
    return (
      this.getValue('wpSRegistreDefauts3InputOverVoltage') !== 0 ||
      this.getValue('wpSRegistreDefauts3SamplingVoltageFailure') !== 0 ||
      this.getValue('wpSRegistreDefauts3OverUnderVoltageFailure') !== 0 ||
      this.getValue('wpSRegistreDefauts3InputOvercurrentProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts3IpmProtection') !== 0 ||
      this.getValue('wpSRegistreDefauts3DCFanMotorDriverBoardProtection') !== 0
    );
  }

  transformToHexa(data: number[], maxLength: number): string {
    let v = 0;
    for (let i = data.length - 1; i >= 0; i--) {
      v = (v << 1) | data[i];
    }
    return v.toString(16).toUpperCase().padStart(maxLength, '0');
  }

  getRegistreDefauts2Hexa(): string {
    return this.transformToHexa(
      [
        this.getValue('wpSRegistreDefauts2CompressorOverloadProtection'),
        this.getValue('wpSRegistreDefauts2HighPressureProtection'),
        this.getValue('wpSRegistreDefauts2LowPressureProtection'),
        this.getValue('wpSRegistreDefauts2WaterFlowProtection'),
        this.getValue('wpSRegistreDefauts2AntifreezingProtection'),
        this.getValue('wpSRegistreDefauts2HighDischargeTemperatureProtection'),
        this.getValue('wpSRegistreDefauts2MOPDriveWarning'),
        this.getValue('wpSRegistreDefauts2ConverterBoardOffline'),
        this.getValue('wpSRegistreDefauts2IPMProtection'),
        this.getValue('wpSRegistreDefauts2CompressorStartFailure'),
        this.getValue('wpSRegistreDefauts2ConverterInputLostPhase'),
        this.getValue('wpSRegistreDefauts2IPMSamplingCurrentFailure'),
        this.getValue('wpSRegistreDefauts2ConverterOverheatProtection'),
        this.getValue('wpSRegistreDefauts2ConverterDCOverVoltage'),
        this.getValue('wpSRegistreDefauts2ConverterDCUnderVoltage'),
        this.getValue('wpSRegistreDefauts2InputUnderVoltage'),
      ],
      4,
    );
  }

  getRegistreDefauts3Hexa(): string {
    return this.transformToHexa(
      [
        this.getValue('wpSRegistreDefauts3InputOverVoltage'),
        this.getValue('wpSRegistreDefauts3SamplingVoltageFailure'),
        this.getValue('wpSRegistreDefauts3DspPfcConnectionFailure'),
        this.getValue('wpSRegistreDefauts3RadiatorTemperatureSensingFailure'),
        this.getValue('wpSRegistreDefauts3OverUnderVoltageFailure'),
        this.getValue('wpSRegistreDefauts3PfcFailure'),
        this.getValue('wpSRegistreDefauts3IpmOverheatProtection'),
        this.getValue('wpSRegistreDefauts3WeakMagneticProtection'),
        this.getValue('wpSRegistreDefauts3InputOverCurrentWarning'),
        this.getValue('wpSRegistreDefauts3ConverterOverheatWarning'),
        this.getValue('wpSRegistreDefauts3InputOvercurrentProtection'),
        this.getValue('wpSRegistreDefauts3EepromErrorWarning'),
        this.getValue('wpSRegistreDefauts3IpmProtection'),
        this.getValue('wpSRegistreDefauts3DCFanMotorDriverBoardProtection'),
        this.getValue('wpSRegistreDefauts3PressureSensorFailure'),
        this.getValue('wpSRegistreDefauts3InputCoverCurrent'),
      ],
      4,
    );
  }

  getRegistreDefauts4Hexa(): string {
    return this.transformToHexa(
      [
        this.getValue('wpSRegistreDefauts4AntiFreezingProtection'),
        this.getValue('wpSRegistreDefauts4AntiFreezingProtectionHeatingMode'),
        this.getValue('wpSRegistreDefauts4ECFanMotorSignalFailure'),
        this.getValue('wpSRegistreDefauts4FanMotor1Failure'),
        this.getValue('wpSRegistreDefauts4FanMotor2Failure'),
        this.getValue('wpSRegistreDefauts4DCFanMotorCommunicationFailure'),
        this.getValue('wpSRegistreDefauts4InletOutletTempDifferenceTooMuch'),
        this.getValue('wpSRegistreDefauts4LowAmibentTempProtection'),
        this.getValue('wpSRegistreDefauts4CoilTempSensor2Failure'),
      ],
      4,
    );
  }

  getSwitchesHexa(): string {
    return this.transformToHexa(
      [
        this.getValue('wpSEtatSwitchsHPSwitch'),
        this.getValue('wpSEtatSwitchsLPSwitch'),
        this.getValue('wpSEtatSwitchsWaterFlowSwitch'),
        this.getValue('wpSEtatSwitchsRemoteOnOff'),
        this.getValue('wpSEtatSwitchsmodeRemote'),
        this.getValue('wpSEtatSwitchsMasterAndSlave'),
      ],
      2,
    );
  }

  getBypassPacValue(): string {
    const bypassValue = this.getValue('wpSBypassPac');
    if (bypassValue === 0) {
      return '--';
    }
    return this.translateService.instant(
      'P00061.status.code.default.reglage.debit.value.' + bypassValue,
    );
  }

  getTemperatureFctHorloge(): string {
    if (this.getValue('wpSCommandeHorloge') === 0) {
      return '-';
    }
    return getTemperature(
      this.getValue('wpSTemperatureConsigneHorloge') / 10,
      1,
    );
  }

  getPuissanceCalculee(): string {
    const tension = this.getValue('wpSTensionSecteur');
    const courant = this.getValue('wpSCourantConsomme');
    return ((tension * courant) / 10).toFixed(0) + ' W';
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly getTemperature = getTemperature;
  protected readonly brandOverride = brandOverride;
}
